import { render, staticRenderFns } from "./JsonInterpreter.vue?vue&type=template&id=654007a2&scoped=true&"
import script from "./JsonInterpreter.vue?vue&type=script&lang=js&"
export * from "./JsonInterpreter.vue?vue&type=script&lang=js&"
import style0 from "./JsonInterpreter.vue?vue&type=style&index=0&id=654007a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654007a2",
  null
  
)

export default component.exports